import {Component} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';

@Component({
    selector: 'np-no-access',
    templateUrl: './noAccess.component.html',
    styleUrls: ['./noAccess.component.css'],
    standalone: false
})
export class NoAccessComponent {
    constructor(private http: HttpClient) {
    }

    async logout(): Promise<void> {
        await lastValueFrom(this.http.post('api/auth/logout', {})).catch(() => null);
        window.location.href = '/login';
    }
}
